var lists_default = {
  "fontElementMap": "_-0A2h",
  "orderedlist": "NJ-XM",
  "bulletedlist": "DMq0y",
  "listItem": "yHPaP"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
